import React, { useEffect, useState } from "react";
import { Dimensions, FlatList, Platform, ScrollView, TouchableOpacity, View, Image } from "react-native";
import { BottomBarDLSType, ButtonTypeDLS, ButtonWidthTypeToken, ColorTokens, IconSizeTokens, IconTokens, LottieSizeTokens, LottieTokens, TextAlignTokens, TypographyTypeDLS } from "@voltmoney/schema";
import { ModalAlignmentEnum } from '@voltmoney/types';
import { Typography } from "../../typography/Typography";
import { Icon } from "../../icon/Icon";
import { Header } from "../../header/Header";
import { isMobile } from "../../stack/utils";
import BoilerPlate from "../boilerPlate/BoilerPlate";
import BottomBar from "../../bottomBarDLS/bottomBarDLS";
import { Button } from "../../button/Button";
import BottomSheet from "../BottomSheet";
import { Lottie } from "../../lottie/Lottie";
import { getScreenType } from "../utils";
import LottieView from "lottie-react-native";
const ASESDocumentsListing = ({ height, triggerAction, goBackAction, needHelpAction, stepperData, type, submitAction, uploadDocumentsAction, documentsListing, continueAction, isFromJupiter }) => {
    const [allDocumentsUploaded, setAllDocumentsUploaded] = useState(false);
    const [submitClicked, setSubmitClicked] = useState(false);
    const [showSuccessCard, setShowSuccessCard] = useState(false);
    const [halfCardHeight, setHalfCardHeight] = useState(0);
    useEffect(() => {
        if (documentsListing) {
            const statuses = documentsListing.map(document => document.status);
            if (statuses.includes("PENDING")) {
                setAllDocumentsUploaded(false);
            }
            else {
                setAllDocumentsUploaded(true);
            }
        }
    }, [documentsListing, allDocumentsUploaded]);
    useEffect(() => {
        if (!allDocumentsUploaded) {
            setHalfCardHeight(Platform.OS === "ios" ? 210 : 180);
        }
        else {
            setHalfCardHeight(Platform.OS === "ios" ? 250 : 230);
        }
    }, [allDocumentsUploaded]);
    const headerView = () => {
        return (React.createElement(View, { style: { ...Platform.OS === "ios" && { marginTop: 24 } } },
            React.createElement(Header, { id: "bt_borrowerKyc_goBack", needHelpIcon: true, needHelpAction: () => triggerAction(needHelpAction), type: type, stepperProps: stepperData, isBackButton: true, title: "Upload documents", onPress: () => {
                    if (goBackAction) {
                        triggerAction(goBackAction);
                    }
                }, isFromJupiter: isFromJupiter })));
    };
    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    };
    const colorStates = (status) => {
        let backgroundColor;
        let textColor;
        switch (status) {
            case "PENDING":
                backgroundColor = '#FEF4E6';
                textColor = ColorTokens.System_Warning;
                break;
            case "UPLOADED":
                backgroundColor = '#E7F4ED';
                textColor = ColorTokens.System_Happy;
                break;
        }
        return { backgroundColor, textColor };
    };
    const renderSuccessHalfCard = () => {
        return (React.createElement(View, { style: { padding: 16, alignContent: 'center', alignItems: 'center' } },
            Platform.OS === 'ios'
                && React.createElement(LottieView, { source: { uri: "https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json" }, style: { width: 70, height: 70 }, autoPlay: true, loop: true }),
            Platform.OS !== "ios" &&
                React.createElement(Lottie, { uri: LottieTokens.Success, size: LottieSizeTokens.LG, autoplay: true, loop: true }),
            React.createElement(View, { style: { marginTop: 16, marginBottom: 4, alignSelf: 'center', alignItems: 'center' } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, label: "Documents uploaded successfully", color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center })),
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: "You will be redirected to next step in few seconds", color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.center }),
            React.createElement(View, { style: { marginTop: 24, width: '100%' } },
                React.createElement(Button, { typeDLS: ButtonTypeDLS.SECONDARY, label: "Continue", width: ButtonWidthTypeToken.FULL, onPress: () => {
                        setSubmitClicked(false);
                        triggerAction({
                            ...continueAction
                        });
                    } }))));
    };
    const individualCardView = (item) => {
        const { backgroundColor, textColor } = colorStates(item?.status);
        const statusLength = item?.status?.length;
        return (React.createElement(View, { style: { marginTop: 16 } },
            React.createElement(View, { style: {
                    borderTopRightRadius: 8,
                    borderTopLeftRadius: 8,
                    borderWidth: 2,
                    padding: 16,
                    borderColor: '#F9FAFB'
                } },
                React.createElement(View, { style: {
                        height: 20,
                        width: statusLength + 54,
                        paddingVertical: 2,
                        backgroundColor: backgroundColor,
                        marginBottom: 8,
                        borderRadius: 4,
                        alignContent: 'center',
                        alignItems: 'center'
                    } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B3S, label: capitalizeFirstLetter(item?.status), color: textColor })),
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H3S, label: item?.documentDisplayName, color: ColorTokens.Grey_Night, numberOfLines: 2 }),
                React.createElement(View, { style: { marginTop: 8 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B0R, label: item?.description, color: ColorTokens.Grey_Charcoal }))),
            React.createElement(TouchableOpacity, { style: {
                    borderBottomLeftRadius: 8,
                    borderBottomRightRadius: 8,
                    borderWidth: 1,
                    backgroundColor: '#FAFBFE',
                    paddingHorizontal: 16,
                    paddingVertical: 12,
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    borderColor: '#F9FAFB'
                }, onPress: () => {
                    triggerAction({
                        ...uploadDocumentsAction,
                        payload: {
                            documentDetails: item,
                        }
                    });
                } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B0S, label: item?.status === "UPLOADED" ? "Edit document" : "Sign document", color: ColorTokens.Primary_100 }),
                React.createElement(Icon, { name: IconTokens.RightBlueArrow, size: IconSizeTokens.XXL }))));
    };
    const bodyView = () => {
        return (React.createElement(View, { style: { marginTop: 16, paddingHorizontal: 16 } },
            React.createElement(View, { style: {
                    height: 52,
                    backgroundColor: '#F3FAF6',
                    borderRadius: 12,
                    flexDirection: 'row',
                    paddingVertical: 8,
                    paddingHorizontal: 16,
                    alignContent: 'center',
                    alignItems: 'center'
                } },
                React.createElement(Image, { source: { uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/document_green.png" }, style: { width: 16, height: 20 } }),
                React.createElement(View, { style: { marginLeft: 8, flexShrink: 1 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Night, label: "Your application is almost complete. We just require a few additional documents." }))),
            React.createElement(ScrollView, { showsVerticalScrollIndicator: false },
                React.createElement(FlatList, { showsVerticalScrollIndicator: false, data: documentsListing, renderItem: ({ item }) => individualCardView(item), style: { paddingBottom: 16 } }))));
    };
    const renderUploadAllDocumentsCard = () => {
        return (React.createElement(View, { style: { alignContent: 'center', alignItems: 'center', padding: 16 } },
            React.createElement(Icon, { name: IconTokens.ErrorIcon, size: IconSizeTokens.XXXXXXL }),
            React.createElement(View, { style: { marginTop: 16, marginBottom: 24 } },
                React.createElement(Typography, { label: "Upload all documents to proceed", typeDLS: TypographyTypeDLS.H3S, color: ColorTokens.Grey_Night })),
            React.createElement(Button, { label: "Okay", typeDLS: ButtonTypeDLS.PRIMARY, width: ButtonWidthTypeToken.FULL, onPress: () => {
                    setAllDocumentsUploaded(false);
                    setSubmitClicked(false);
                } })));
    };
    const footerView = () => {
        return (React.createElement(BottomBar, { typeDLS: BottomBarDLSType.TYPE_A, btnLoading: false, btnLabel: "Submit", onPress: () => {
                setSubmitClicked(true);
                if (allDocumentsUploaded) {
                    triggerAction({
                        ...submitAction
                    });
                }
            }, isPositionAbsolute: false, btnTypeDLS: ButtonTypeDLS.PRIMARY, labelColor: ColorTokens.White }));
    };
    const renderCasesModal = () => {
        if (!allDocumentsUploaded)
            return renderUploadAllDocumentsCard();
        else
            return renderSuccessHalfCard();
    };
    return (React.createElement(View, { style: { marginHorizontal: -16 } },
        React.createElement(BoilerPlate, { height: height - 16, headerChild: React.createElement(React.Fragment, null, headerView()), bottomChildren: React.createElement(React.Fragment, null, footerView()) }, React.createElement(React.Fragment, null, bodyView())),
        submitClicked &&
            React.createElement(View, { style: { position: 'absolute', bottom: 0 } },
                React.createElement(BottomSheet, { autoAdjustHeight: false, height: halfCardHeight, width: '100%', closeFunction: () => setAllDocumentsUploaded(false), alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: false, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width)) ? Platform.OS !== "ios" ? Dimensions.get('window').height : Dimensions.get('window').height + 5 : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508 }, renderCasesModal()))));
};
export default (ASESDocumentsListing);
